import { render } from "./KundenantragTeilnehmerCreate.vue?vue&type=template&id=56ea863e"
import script from "./KundenantragTeilnehmerCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./KundenantragTeilnehmerCreate.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/KundenantragTeilnehmerCreate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56ea863e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56ea863e', __exports__)) {
    api.reload('56ea863e', __exports__)
  }
  
  module.hot.accept("./KundenantragTeilnehmerCreate.vue?vue&type=template&id=56ea863e", () => {
    api.rerender('56ea863e', render)
  })

}


export default __exports__